export class Theme {
  constructor(
    public themeName: string,
    public isDark: boolean
  ) {}
}
